var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M14.066 9.878c.269-.572.434-1.202.434-1.878A4.498 4.498 0 0 0 10 3.5c-1.041 0-2.05.367-2.848 1.035l2.3 1.777c.027-.102.043-.207.048-.312a1.49 1.49 0 0 0-.29-.882 2.961 2.961 0 0 1 3.627 3.81l1.229.95zm5.74 4.437a.5.5 0 0 1 .089.702l-.614.79a.5.5 0 0 1-.702.087L.193 1.684A.5.5 0 0 1 .105.983L.72.193A.5.5 0 0 1 1.42.105l3.975 3.073A9.63 9.63 0 0 1 10 2c3.842 0 7.197 2.237 8.891 5.544a1.01 1.01 0 0 1 0 .912 10.352 10.352 0 0 1-2.539 3.19l3.455 2.67zM10 12.5c.273-.003.545-.03.813-.082l1.621 1.255A9.707 9.707 0 0 1 10 14c-3.842 0-7.197-2.237-8.891-5.544a1.01 1.01 0 0 1 0-.912c.32-.625.716-1.197 1.147-1.737L5.534 8.34C5.711 10.665 7.63 12.5 10 12.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.69965ee791e6d5de18e0cd15335eb7c6.svg";
export { ForwardRef as ReactComponent };